import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList from "../Data.List/index.js";
import * as Data$dMap from "../Data.Map/index.js";
import * as Data$dMap$dExtra from "../Data.Map.Extra/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMultiSet from "../Data.MultiSet/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrderedMultiSet from "../Data.OrderedMultiSet/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Restaumatic$dMenu$dV2$dMenuCatalogue from "../Restaumatic.Menu.V2.MenuCatalogue/index.js";
import * as Restaumatic$dMenu$dV2$dParameter from "../Restaumatic.Menu.V2.Parameter/index.js";
import * as Restaumatic$dMenu$dV2$dParametric from "../Restaumatic.Menu.V2.Parametric/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
const fromFoldable = /* #__PURE__ */ Data$dMap$dInternal.fromFoldable(Data$dOrd.ordString)(Data$dFoldable.foldableArray);
const toUnfoldable = /* #__PURE__ */ (() => {
  const $0 = Data$dList.toUnfoldable(Data$dUnfoldable.unfoldableArray);
  return x => $0(Data$dMap$dInternal.keys(x));
})();
const partitionWithKey = /* #__PURE__ */ Data$dMap$dExtra.partitionWithKey(Data$dOrd.ordString);
const fromOccurArray = /* #__PURE__ */ Data$dOrderedMultiSet.fromOccurArray(Data$dEq.eqString);
const toMultiSet = /* #__PURE__ */ Data$dMultiSet.fromOccurArray(Data$dOrd.ordString);
const monoidMap = /* #__PURE__ */ Data$dMap$dInternal.monoidMap(Data$dOrd.ordString);
const fold = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(monoidMap)(Data$dFoldable.identity))();
const any = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap((() => {
  const semigroupDisj1 = {append: v => v1 => v || v1};
  return {mempty: false, Semigroup0: () => semigroupDisj1};
})()))();
const fold1 = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(monoidMap)(Data$dFoldable.identity))();
const mempty = /* #__PURE__ */ (() => Data$dMap$dInternal.monoidMap(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId).mempty)();
const eqMultiSet = /* #__PURE__ */ Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Data$dEq.eqInt);
const unwrapCartProductPartKey = x => {
  const $0 = Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, Data$dRecord.unsafeGet("parts")(x), 0);
  if ($0.tag === "Just") { return $0._1; }
  $runtime.fail();
};
const saveDefaultMap = dictOrd => dictEq => v => v1 => Data$dMap$dInternal.filterWithKey(dictOrd)(k => v2 => {
  const $0 = Data$dMap$dInternal.lookup(dictOrd)(k)(v1);
  if ($0.tag === "Nothing") { return true; }
  if ($0.tag === "Just") { return !dictEq.eq($0._1)(v2); }
  return true;
})(v);
const overwriteDefaultMap = dictOrd => {
  const compare = dictOrd.compare;
  return dictEq => v => v1 => Data$dMap$dInternal.unsafeUnionWith(compare, Data$dFunction.const, v, v1);
};
const mkProductKeyImpl = catalogueMemo => productId => product => params => {
  const providedCustomParametersValues = Restaumatic$dMenu$dV2$dParametric.onlyCustomParameterValues(params);
  const notProvidedCustomParameters = Data$dMap$dInternal.unsafeDifference(
    Data$dOrd.ordString.compare,
    Restaumatic$dMenu$dV2$dParametric.onlyCustomParameters(Restaumatic$dMenu$dV2$dParameter.productParameters(catalogueMemo)(productId)),
    Data$dMap.keys(providedCustomParametersValues)
  );
  const catalogue = catalogueMemo.catalogue;
  const v = partitionWithKey(paramId => _v => {
    const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(paramId)(Data$dRecord.unsafeGet("customParameters")(catalogue));
    if ($0.tag === "Nothing") { return false; }
    if ($0.tag === "Just") { return $0._1.divisible; }
    $runtime.fail();
  })(Data$dMap$dInternal.unsafeUnionWith(
    Data$dOrd.ordString.compare,
    Data$dFunction.const,
    providedCustomParametersValues,
    fromFoldable(Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(paramId => {
      const $0 = Data$dTuple.Tuple(paramId);
      const $1 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(paramId)(Data$dRecord.unsafeGet("customParameters")(catalogue));
      const $2 = (() => {
        if ($1.tag === "Just") { return $1._1.defaultChoice; }
        if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
        $runtime.fail();
      })();
      if ($2.tag === "Just") { return Data$dMaybe.$Maybe("Just", $0($2._1)); }
      return Data$dMaybe.Nothing;
    })(toUnfoldable(notProvidedCustomParameters))))
  ));
  const modifierSettings = product.modifierSettings;
  const allModifiers = Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(modifierId => {
    const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(modifierId)(Data$dRecord.unsafeGet("modifiers")(catalogue));
    if ($0.tag === "Just") {
      const settings = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(modifierId)(modifierSettings);
      const $1 = Restaumatic$dMenu$dV2$dMenuCatalogue.modifierDefaultChoices($0._1);
      const $2 = Data$dFunctor.arrayMap(Data$dTuple$dT2.toTuple);
      const $3 = settings.tag === "Just" ? settings._1.defaultItems : Data$dMaybe.Nothing;
      const defaultChoices = (() => {
        if ($3.tag === "Nothing") { return $1; }
        if ($3.tag === "Just") { return fromOccurArray($2($3._1)); }
        $runtime.fail();
      })();
      if (Restaumatic$dMenu$dV2$dParametric.isParametricPossibleBoole.isPossible($0._1.availableWhen)(params)) {
        return Data$dMaybe.$Maybe(
          "Just",
          {
            divisible: Data$dRecord.unsafeGet("divisible")($0._1),
            items: Data$dMap$dInternal.$$$Map("Node", 1, 1, modifierId, toMultiSet(defaultChoices), Data$dMap$dInternal.Leaf, Data$dMap$dInternal.Leaf),
            requiresUserInput: Restaumatic$dMenu$dV2$dParametric.isParametricPossibleBoole.isPossible(Data$dRecord.unsafeGet("userInputRequiredWhen")($0._1))(params) || (() => {
              if (settings.tag === "Nothing") { return false; }
              if (settings.tag === "Just") {
                return Restaumatic$dMenu$dV2$dParametric.isParametricPossibleBoole.isPossible(Data$dRecord.unsafeGet("inputRequired")(settings._1))(params);
              }
              $runtime.fail();
            })(),
            canBeEdited: Restaumatic$dMenu$dV2$dParametric.isParametricPossibleBoole.isPossible(Data$dRecord.unsafeGet("userEditableWhen")($0._1))(params) || (() => {
              if (settings.tag === "Nothing") { return false; }
              if (settings.tag === "Just") {
                return Restaumatic$dMenu$dV2$dParametric.isParametricPossibleBoole.isPossible(Data$dRecord.unsafeGet("editable")(settings._1))(params);
              }
              $runtime.fail();
            })()
          }
        );
      }
      return Data$dMaybe.Nothing;
    }
    if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
    $runtime.fail();
  })(Data$dSemigroup.concatArray(product.productModifiers)((() => {
    const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(product.category)(Data$dRecord.unsafeGet("categories")(catalogue));
    if ($0.tag === "Nothing") { return []; }
    if ($0.tag === "Just") { return $0._1.categoryModifiers; }
    $runtime.fail();
  })())));
  const v1 = Data$dArray.partitionImpl(v2 => v2.divisible, allModifiers);
  return {
    divisible: {customParameters: v.yes, modifiers: fold(Data$dFunctor.arrayMap(v2 => v2.items)(v1.yes))},
    nondivisible: {customParameters: v.no, modifiers: fold(Data$dFunctor.arrayMap(v2 => v2.items)(v1.no))},
    requiresCreator: any(v2 => v2.requiresUserInput)(allModifiers) || !(notProvidedCustomParameters.tag === "Leaf"),
    canBeEdited: any(v2 => v2.canBeEdited)(allModifiers)
  };
};
const mkProductKey = catalogue => productId => product => params => {
  const v = mkProductKeyImpl(catalogue)(productId)(product)(params);
  return {
    productKey: v$1 => (
      {
        customParameters: v.nondivisible.customParameters,
        modifiers: v.nondivisible.modifiers,
        parts: [{productId, customParameters: v.divisible.customParameters, modifiers: v.divisible.modifiers}]
      }
    ),
    requiresCreator: v.requiresCreator,
    canBeEdited: v.canBeEdited
  };
};
const mkProductCreatorKey = catalogue => creatorProducts => params => {
  const allProducts = Data$dFunctor.arrayMap(v => Data$dTuple.$Tuple(v._1, mkProductKeyImpl(catalogue)(v._1)(v._2)(params)))(creatorProducts);
  return {
    customParameters: fold1(Data$dFunctor.arrayMap(x => x._2.nondivisible.customParameters)(allProducts)),
    modifiers: fold1(Data$dFunctor.arrayMap(x => x._2.nondivisible.modifiers)(allProducts)),
    parts: Data$dFunctor.arrayMap(v => ({productId: v._1, customParameters: v._2.divisible.customParameters, modifiers: v._2.divisible.modifiers}))(allProducts)
  };
};
const mkComboKey = catalogueMemo => comboId => combo => environmentParams => {
  const catalogue = catalogueMemo.catalogue;
  return {
    comboId,
    elements: fromFoldable(Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(v => {
      if (v._2.defaultChoice.tag === "Just") {
        const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(v._2.defaultChoice._1)(v._2.choices._1);
        if ($0.tag === "Just") {
          const $1 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)($0._1.product)(Data$dRecord.unsafeGet("products")(catalogue));
          if ($1.tag === "Just") {
            const v1 = mkProductKeyImpl(catalogueMemo)($0._1.product)($1._1)(Data$dMap$dInternal.unsafeUnionWith(
              Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId.compare,
              Data$dFunction.const,
              Restaumatic$dMenu$dV2$dParametric.fromCustomParameterValues($0._1.customParameterValues),
              environmentParams
            ));
            return Data$dMaybe.$Maybe(
              "Just",
              Data$dTuple.$Tuple(
                v._1,
                {
                  comboChoiceId: v._2.defaultChoice._1,
                  customParameters: Data$dMap$dInternal.unsafeUnionWith(
                    Data$dOrd.ordString.compare,
                    Data$dFunction.const,
                    v1.nondivisible.customParameters,
                    v1.divisible.customParameters
                  ),
                  modifiers: Data$dMap$dInternal.unsafeUnionWith(Data$dOrd.ordString.compare, Data$dFunction.const, v1.nondivisible.modifiers, v1.divisible.modifiers)
                }
              )
            );
          }
          if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
          $runtime.fail();
        }
        if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
        $runtime.fail();
      }
      if (v._2.defaultChoice.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    })(combo.elements._2)))
  };
};
const defaultCartProductKey = catalogue => productId => product => mkProductCreatorKey({catalogue, parametersMemo: {value: Data$dMap$dInternal.Leaf}})([
  Data$dTuple.$Tuple(productId, product)
])(mempty);
const overwriteProductParts = catalogue => v => Data$dFunctor.arrayMap(newPart => {
  const productId = Data$dRecord.unsafeGet("productId")(newPart);
  const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(productId)(Data$dRecord.unsafeGet("products")(catalogue));
  if ($0.tag === "Just") {
    return {
      productId,
      customParameters: Data$dMap$dInternal.unsafeUnionWith(
        Data$dOrd.ordString.compare,
        Data$dFunction.const,
        Data$dRecord.unsafeGet("customParameters")(newPart),
        Data$dRecord.unsafeGet("customParameters")(unwrapCartProductPartKey(defaultCartProductKey(catalogue)(productId)($0._1)))
      ),
      modifiers: Data$dMap$dInternal.unsafeUnionWith(
        Data$dOrd.ordString.compare,
        Data$dFunction.const,
        Data$dRecord.unsafeGet("modifiers")(newPart),
        Data$dRecord.unsafeGet("modifiers")(unwrapCartProductPartKey(defaultCartProductKey(catalogue)(productId)($0._1)))
      )
    };
  }
  return newPart;
})(v);
const overwriteCartProductKey = catalogue => newKey => {
  const productId = Data$dRecord.unsafeGet("productId")(unwrapCartProductPartKey(newKey));
  const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(productId)(Data$dRecord.unsafeGet("products")(catalogue));
  if ($0.tag === "Just") {
    return {
      customParameters: Data$dMap$dInternal.unsafeUnionWith(
        Data$dOrd.ordString.compare,
        Data$dFunction.const,
        Data$dRecord.unsafeGet("customParameters")(newKey),
        Data$dRecord.unsafeGet("customParameters")(defaultCartProductKey(catalogue)(productId)($0._1))
      ),
      modifiers: Data$dMap$dInternal.unsafeUnionWith(
        Data$dOrd.ordString.compare,
        Data$dFunction.const,
        Data$dRecord.unsafeGet("modifiers")(newKey),
        Data$dRecord.unsafeGet("modifiers")(defaultCartProductKey(catalogue)(productId)($0._1))
      ),
      parts: overwriteProductParts(catalogue)(Data$dRecord.unsafeGet("parts")(newKey))
    };
  }
  return newKey;
};
const saveProductParts = catalogue => v => Data$dFunctor.arrayMap(newPart => {
  const productId = Data$dRecord.unsafeGet("productId")(newPart);
  const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(productId)(Data$dRecord.unsafeGet("products")(catalogue));
  if ($0.tag === "Just") {
    return {
      productId,
      customParameters: saveDefaultMap(Data$dOrd.ordString)(Data$dEq.eqString)(Data$dRecord.unsafeGet("customParameters")(newPart))(Data$dRecord.unsafeGet("customParameters")(unwrapCartProductPartKey(defaultCartProductKey(catalogue)(productId)($0._1)))),
      modifiers: saveDefaultMap(Data$dOrd.ordString)(eqMultiSet)(Data$dRecord.unsafeGet("modifiers")(newPart))(Data$dRecord.unsafeGet("modifiers")(unwrapCartProductPartKey(defaultCartProductKey(catalogue)(productId)($0._1))))
    };
  }
  return newPart;
})(v);
const saveCartProductKey = catalogue => newKey => {
  const productId = Data$dRecord.unsafeGet("productId")(unwrapCartProductPartKey(newKey));
  const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(productId)(Data$dRecord.unsafeGet("products")(catalogue));
  if ($0.tag === "Just") {
    return {
      customParameters: saveDefaultMap(Data$dOrd.ordString)(Data$dEq.eqString)(Data$dRecord.unsafeGet("customParameters")(newKey))(Data$dRecord.unsafeGet("customParameters")(defaultCartProductKey(catalogue)(productId)($0._1))),
      modifiers: saveDefaultMap(Data$dOrd.ordString)(eqMultiSet)(Data$dRecord.unsafeGet("modifiers")(newKey))(Data$dRecord.unsafeGet("modifiers")(defaultCartProductKey(catalogue)(productId)($0._1))),
      parts: saveProductParts(catalogue)(Data$dRecord.unsafeGet("parts")(newKey))
    };
  }
  return newKey;
};
export {
  any,
  defaultCartProductKey,
  eqMultiSet,
  fold,
  fold1,
  fromFoldable,
  fromOccurArray,
  mempty,
  mkComboKey,
  mkProductCreatorKey,
  mkProductKey,
  mkProductKeyImpl,
  monoidMap,
  overwriteCartProductKey,
  overwriteDefaultMap,
  overwriteProductParts,
  partitionWithKey,
  saveCartProductKey,
  saveDefaultMap,
  saveProductParts,
  toMultiSet,
  toUnfoldable,
  unwrapCartProductPartKey
};
